import React from "react";
import { FINAL_CTA } from "@/data/content";
import { Container, Section, Reveal, FlyIn } from "@/components/landing/shared";
import { LeadForm } from "@/components/landing/LeadForm";

const ClosingPitch = () => (
  <Reveal>
    <h2 className="font-display text-balance leading-[1.04] tracking-[-0.03em]" data-testid="final-cta-headline">
      <span className="block text-[2.1rem] sm:text-[2.7rem] lg:text-[3.1rem]">{FINAL_CTA.headlineMain}</span>
      <span className="mt-2 block text-[1.3rem] text-[#D9DEE5] sm:text-[1.55rem] lg:text-[1.75rem]">{FINAL_CTA.headlineSub}</span>
    </h2>
  </Reveal>
);

export const FinalCTA = () => {
  return (
    <Section id="contact" navId="contact" className="dark-section grain-dark relative overflow-hidden">
      <Container className="section-y relative">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-6">
            <ClosingPitch />
          </div>
          <div className="lg:col-span-6">
            {/* The form flies in from the left edge of the screen, driven by scroll position. */}
            <FlyIn from="left" distance="90vw" settleAt={0.55} data-testid="lead-form-flyin">
              <LeadForm />
            </FlyIn>
          </div>
        </div>
      </Container>
    </Section>
  );
};
